// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue4169(props) {
    return (
        <svg
            id="_x34_169"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"
                }
            </style>
            <g id="MIA">
                <g id="compass">
                    <path
                        className="st0"
                        d="M231.5,191.8l-3.1,8.6l-5.2,6.1l2.3-7.7L231.5,191.8z"
                    />
                    <path
                        className="st1"
                        d="M234.5,185.9c7.5,4.1,10.2,13.6,6.1,21.1c-4.1,7.5-13.6,10.2-21.1,6.1c-7.5-4.1-10.2-13.6-6.1-21.1 C217.6,184.5,227,181.8,234.5,185.9z M220.2,211.9c6.8,3.8,15.5,1.3,19.3-5.6c3.8-6.8,1.3-15.5-5.6-19.3 c-6.8-3.8-15.5-1.3-19.3,5.6C210.8,199.5,213.3,208.2,220.2,211.9z"
                    />
                    <path
                        className="st0"
                        d="M224.2,200.3c-0.5-1.6,0.5-3.2,2-3.7c1.6-0.5,3.2,0.5,3.7,2c0.5,1.6-0.5,3.2-2,3.7 C226.3,202.8,224.6,201.9,224.2,200.3z M223.6,208.2l-1.5,2.7l-0.4-0.2l-0.2-2.5l-1,1.9l-0.5-0.3l1.5-2.7l0.4,0.2l0.2,2.5l1-1.9 L223.6,208.2z"
                    />
                    <path
                        className="st2"
                        d="M225.4,200c-0.3-0.9,0.3-1.8,1.1-2c0.9-0.3,1.8,0.3,2,1.1c0.3,0.9-0.3,1.8-1.1,2 C226.6,201.4,225.7,200.9,225.4,200z"
                    />
                </g>
                <g id="distances">
                    <text
                        id="right"
                        transform="matrix(1 0 0 1 229.6678 112.2565)"
                        className="st3 st4 st5"
                    >
                        335
                    </text>
                    <text
                        id="right-center_1_"
                        transform="matrix(1 0 0 1 164.8248 46.366)"
                        className="st3 st4 st5"
                    >
                        387
                    </text>
                    <text
                        id="center"
                        transform="matrix(1 0 0 1 89.7701 33.6937)"
                        className="st3 st4 st5"
                    >
                        400
                    </text>
                    <text
                        id="left-center_1_"
                        transform="matrix(1 0 0 1 53.6915 49.5938)"
                        className="st3 st4 st5"
                    >
                        382
                    </text>
                    <text
                        id="left"
                        transform="matrix(1 0 0 1 3.813 99.3971)"
                        className="st3 st4 st5"
                    >
                        344
                    </text>
                </g>
                <g id="field">
                    <path
                        id="Outfield_00000079455967559065699190000006373183002832104345_"
                        className="st6"
                        d="M23.1,102.6l-2.1,3.2l87.1,105.6 c18.4,22.3,34.3-0.3,34.3-0.3l84.4-102.6l-3.1-3.9l-1.5-1.9l-1.5-1.9l-1.5-1.9l-1.6-2l-1.5-2l-1.6-2l-1.5-2l-1.6-2l-1.6-2l-1.6-2 l-1.6-2.1l-1.7-2.1l-1.7-2.1l-1.7-2.1l-1.7-2.1l-1.8-2.2l-1.7-2.2l-1.8-2.3l-1.8-2.3l-1.8-2.3l-1.9-2.4l-1.9-2.5l-2.2-2l-2.5-1.3 l-2.5-1.3l-2.5-1.3l-2.5-1.3l-2.5-1.4l-2.5-1.2l-2.7-0.7l-2.7-0.6l-2.7-0.6l-2.7-0.6l-2.7-0.6l-2.7-0.7L151,44l-2.7-0.7l-2.8-0.6 l-2.7-0.9l-2.7-1l-2.8-0.5l-2.8-0.4l-2.8-0.5l-2.8-0.6l-2.9-0.7l-2.9-0.7l-3-0.7l-2.9-0.2h-2.9h-2.9h-3h-2.9l-2.9,0.7l-2.6,2.3 l-2.6,2L94.1,43l-2.7,1.1l-2.7,0.8L86,45.6l-2.7,0.8l-2.7,1L78,48.5l-2.5,1.3L73,51.3l-2.5,1.5l-2.4,1.5l-2.4,1.6l-2.3,1.5 l-2.3,1.7L58.9,61l-2.2,1.8l-2.1,1.8l-2.2,1.7l-2.1,1.8l-2,2l-2,2L44.6,74l-1.9,2l-1.9,1.9L39,80l-1.7,2.2l-1.7,2.1L34,86.4 l-1.7,2l-1.5,2.2l-1.4,2.3L28,95.1l-1.4,2.3l-1.3,2.2l-1.3,2.2L23.1,102.6z"
                    />
                    <path
                        id="grass_1_"
                        className="st3"
                        d="M125,214.2c-3.3,0-6.9-0.3-10.7-4.8l-83.5-102l6.5-10.3l1.3-1.9L45,87l1.5-1.8l9.1-9.4l1.8-1.5 l8.4-6.9l1.9-1.4l2.2-1.4l2.5-1.6l2.4-1.6l2.3-1.5l2.2-1.3l2-1.1l2.1-0.9l2.1-0.8l2.3-0.6l2.8-0.7l3.3-1l3.5-1.5l3.4-1.9l3.3-2.3 l3.3-3l0.9-1c0,0,6.3-1.4,11.2-0.2s47,11.6,47,11.6l6.1,2.6l2,1.4l4.4,4.6l1.5,1.6l9.1,11.5l26.1,32.8l0.8,1l-80.7,98.9 C134.5,211.4,129.9,214.2,125,214.2L125,214.2z"
                    />
                    <path
                        id="infield_sand"
                        className="st6"
                        d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
                    />
                </g>
                <g id="persistent">
                    <g id="mound">
                        <path
                            id="pitching-mound"
                            className="st6"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                        />
                        <path
                            id="pitching-rubber"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4V176.6z"
                        />
                    </g>
                    <g id="lines">
                        <path
                            id="left-foul-line"
                            className="st8"
                            d="M125.2,203.2l-96.7-96.6l-4.8-4.7"
                        />
                        <path
                            id="right-foul-line"
                            className="st8"
                            d="M125.2,203.2l96.6-96.7l1.7-1.8"
                        />
                    </g>
                    <g id="bases_2_">
                        <rect
                            id="third-base_2_"
                            x={99.2}
                            y={175.1}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="first-base_2_"
                            x={148.1}
                            y={175.2}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="second-base_2_"
                            x={123.7}
                            y={148.6}
                            transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)"
                            className="st10"
                            width={3}
                            height={3}
                        />
                        <polygon
                            id="home_2_"
                            className="st7"
                            points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default Venue4169
